import Container from "react-bootstrap/Container";
import BlogList from "../../components/Blog/BlogList";
import BlogTagList from "../../components/Blog/BlogTagList";
import Meta from "../../components/Meta";
import { server } from "../../config";
import { supabase } from "../../utils/supabaseClient"
import blogStyles from '../../styles/Blog.module.css'
import Pagination from "../../components/Blog/Pagination";


const articlePageCount = 21

const getPages = async (tags) => {
  const value = 0
  let pages = tags.reduce((carry, item) => {
    carry[item] = value;
    return carry;
}, {});

  const { data, error} = await supabase
  .from("main_article")
  .select("id, article_status, main_tag (id)")
  .filter('article_status', 'eq', 'published')

  error && console.log(error)

  //count the amount of articles for each tag
  data.forEach(obj => {
    obj.main_tag.forEach(obj2 => {
        pages[obj2.id] += 1
    })
  })

  return [pages, data.length]
}

const getPageAmount = async (tag_slug) => {
 
  const { data, error} = await supabase
  .from("main_article")
  .select("id, article_status, main_tag (tag_slug)")
  .filter('article_status', 'eq', 'published')
  // .filter('main_tag(tag_slug)', 'eq', tag_slug)
  error && console.log(error)

  if (tag_slug === "articles") {
    const pageAmount = Math.ceil(data.length/articlePageCount).toString()
    return pageAmount
  } else {
    const arts = data.filter(obj =>{
      const as = obj.main_tag.filter(a => a.tag_slug === tag_slug)
      if (as.length > 0) {
          return true
      } else {
          return false
      }
    })  //check for slug
    const len = arts.length
    const pageAmount = Math.ceil(len/articlePageCount).toString()
    return pageAmount
  }
}



export async function getStaticPaths() {
  let { data: tags, error } = await supabase
    .from("main_tag")
    .select('id, tag_slug, tag_type, full_name')
    .filter('tag_type', 'eq', 'article')

  const userArticleSlugs = await supabase 
    .from("main_profile")
    .select("username, main_article:main_article_profile_fkey(id, article_status)")

  let userSlugs = userArticleSlugs.data.filter(obj => {
    const pub = obj.main_article.filter(art => art.article_status === "published")
    if (pub.length > 0) {
      return true
    } else {
      return false
    }
  })


  const ps = await getPages(tags.map(obj => obj.id))
  const pages = ps[0]
  const count = ps[1]

  let articlePages = Math.ceil(count/articlePageCount).toString()  //always round up

  let paths = []
  //generate user articles
  userSlugs.forEach(obj => {
    const userArticleCount = obj.main_article.length
    const userPageAmount = Math.ceil(userArticleCount/articlePageCount)
    const username = obj.username
    for (let l = 1; l <= userPageAmount; l++) {
      if (l === 1) {
        paths.push({ params: { slug: [username]}})
      } else {
        paths.push({ params: { slug: [username, l.toString()]}})
      }
    }
  })


  //need a double map to generate all for tags
  for (let j = 0; j < tags.length; j++) {
    const tag_id = tags[j].id
    const tag_slug = tags[j].tag_slug
    let tagPages = Math.ceil(pages[tag_id]/articlePageCount)
    tagPages < 1 && (tagPages = 1)
    for (let k = 1; k <= tagPages; k ++) {
      if (k === 1 ) {
        paths.push({ params: { slug: [tag_slug]}})
      } else {
        paths.push({ params: { slug: [tag_slug, k.toString()]}})
      }
    }
  }

  for (let i = 0; i < articlePages; i++) {
    i === 0 ? paths.push({ params: { slug: ["articles"] }}) :
    paths.push({ params: { slug: ["articles", (i+1).toString()] }})
  }


  error && console.log(error)

  return {
    paths,
    fallback: 'blocking'
  }
}



export async function getStaticProps({params}) {
    let articles
    let title = ''
    let description = ''
    let tag_title = ''
    const slug = params.slug[0]
    let userBool = false
    let range = {start: 0, end: 20}
    const pageNumber = params.slug.length > 1 ? params.slug[1] : 1
    const pageAmount = await getPageAmount(params.slug[0])

    range.start = articlePageCount * (pageNumber - 1)
    range.end = (articlePageCount * pageNumber) - 1

    const { data: tags, error2 } = await supabase
    .from("main_tag")
    .select('id, tag_name, tag_slug, tag_type')
    .filter('tag_type', 'eq', 'article')

    const tagCheck = tags.map(obj => obj.tag_slug)

    !tagCheck.includes(slug) && (userBool = true)

    if (params.slug[0] === "articles") {
      const { data: arts, error } = await supabase
        .from("main_article")
        .select(`id, article_status, article_title, article_published, article_image, article_slug, reading_time,
        main_tag (id, tag_name),
        main_profile!main_article_profile_fkey( user_image, username)`)
        .filter('article_status', 'eq', 'published')
        .order('article_published', { ascending: false })
        .range(range.start, range.end)

      articles = arts
      error && console.log(error)


    } else if (userBool) {
      const userArticles = await supabase 
        .from("main_article")
        .select(`id, article_status, article_title, article_published, article_image, article_slug,
          reading_time,
          main_tag (
           id, tag_name, tag_slug, full_name
          ),
          main_profile!main_article_profile_fkey (
            user_image, username
          )`)
        .filter("article_status", "eq", "published")
        .order('article_published', { ascending: false })

      userArticles.error && console.log(userArticles.error)

      articles = userArticles.data.filter(obj => obj.main_profile.username === slug)

      articles = articles.slice(range.start, range.end + 1)
      title = slug
      tag_title = slug
      description = `Checkout articles written by ${slug}`
      
    } else {
      const { data: arts, error3 } = await supabase
        .from("main_article")
        .select(`id, article_status, article_title, article_published, article_image, article_slug,
         reading_time,
          main_tag (
            id, tag_name, tag_slug, full_name
          ),
          main_profile!main_article_profile_fkey (
             user_image, username
          )`)
        .filter('article_status', 'eq', 'published')
        .order('article_published', { ascending: false })

        
      articles = arts.filter(obj => {
        if (obj.main_tag) {
          const tags = obj.main_tag.map(obj => obj.tag_slug)
          if (tags.includes(params.slug[0])){
            return true
          }
          return false
        }
        return false
      })

      articles = articles.slice(range.start, range.end + 1)

      const {data: name, error} = await supabase
        .from("main_tag")
        .select("full_name, tag_slug, tag_description")
        .eq('tag_slug', params.slug[0])
        .single()

      title = name.full_name
      tag_title = name.tag_slug
      description = name.tag_description
    }


    return {
      props: {
        articles,
        tags,
        title,
        tag_title,
        description,
        params,
        pageAmount
      },
      revalidate: 120,
    };
  }


export default function AllBlogArticles(props) {

  const currentPage = props.params.slug.length > 1 ? props.params.slug[1] : 1

    return (
        <>
          <Meta
            title = {props.pageAmount > 1 && currentPage !== 1 ? 
                      `Page ${currentPage} of ${!props.title ? 'Blog' : props.title}` 
                      : 
                      !props.title ? 'Blog' : props.title
                    }
            description = {!props.description ? 'We offer step-by-step tutorials and other informative content that is easily accessible for all, no matter the skill level.' : props.description }
            url = {`https://ordinarycoders.com/blog/${props.tag_title ? props.tag_title : "articles"}`}
          />
          <Container className="py-5">
              <BlogTagList className="pb-3" tags={props.tags} />
              <h1 className={blogStyles.title}>{props.title}</h1>
              <br />
              <BlogList articles={props.articles} />
              <Pagination 
                previous={props.params.slug.length > 1 ? true : false}
                next={ currentPage < props.pageAmount ? true : false} 
                pagesCount={props.pageAmount}
                currentPage={currentPage}
                tag_slug={props.params.slug[0]}
            />

          </Container> 
        </>      
    )
}

